<style lang="less" scoped>
.td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.after .el-button {height: 40px;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.td {margin-left: 10px;}
table {border-collapse: collapse;width: 100%;}
.first /deep/.el-input{width: 400px;}
/deep/.el-textarea__inner{width: 400px;}
.el-form-item {margin-bottom: 0;float: left;}
.first /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;}
.btnfixed .el-button {height: 40px;margin: 10px auto;margin-top: 10px;}
/deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
/deep/.el-icon-close-tip {display: none;}
</style>

<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form"  class="formBox">
      <table>
        <tr class="username">
          <td class="td_left">
            <span class="f_red">*</span>会员分类
          </td>
          <td class="after">
            <el-form-item prop="username">
              <el-radio-group v-model="form.groupid">
                <el-radio disabled :label="'5'">个人</el-radio>
                <el-radio disabled :label="'6'">企业</el-radio>
                <el-radio disabled :label="'8'">专家</el-radio>
              </el-radio-group>
            </el-form-item>
          </td>
        </tr>
        <tr class="username">
          <td class="td_left">
            <span v-if="isMandatory('username')" class="f_red" >*</span>
            <span v-else class="f_hid">*</span>会员名
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.username" disabled></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="mobile">
          <td class="td_left">
            <span v-if="isMandatory('mobile')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>手机
          </td>
          <td class="after">
            <el-form-item prop="mobile">
              <el-input v-model="form.mobile" disabled></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="email" v-if='form.email'>
          <td class="td_left">
            <span v-if="isMandatory('email')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮箱
          </td>
          <td class="after">
            <el-form-item prop="email">
              <el-input v-model="form.email" disabled></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="passport">
          <td class="td_left">
            <span v-if="isMandatory('passport')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>昵称
          </td>
          <td class="after">
            <el-form-item prop="passport">
              <el-input v-model="form.passport"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="truename">
          <td class="td_left">
            <span v-if="isMandatory('truename')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>姓名
          </td>
          <td class="after">
            <el-form-item prop="truename">
              <el-input v-model="form.truename"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="gender">
          <td class="td_left">
            <span v-if="isMandatory('gender')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>性别
          </td>
          <td class="after">
            <el-form-item prop="gender">
              <el-radio v-model="form.gender" label="1">先生</el-radio>
              <el-radio v-model="form.gender" label="2">女士</el-radio>
            </el-form-item>
          </td>
        </tr>
        <tr class="areaid">
          <td class="td_left">
            <span v-if="isMandatory('areaid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>地区
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.areaid" placeholder="请选择所属国家" class="select">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="resume">
          <td class="td_left">
            <span v-if="isMandatory('resume')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.resume"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
      <!--底部按钮-->
      <div class="btnfixed">
        <el-button type="success" @click="modification()">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  data()
  {
    return {
      //fld表数据
      tableNameDate: [],
      form: {
        id: null,
        groupid: '',
        email: '',
        username: '',
        passport: '',
        mobile: '',
        truename: '',
        gender: '',
        areaid: null,
        resume: ''
      },
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      //表名
      tabname: 'dmcn_member',
      //fld表数据
      fldData: []
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
    if (localStorage.getItem('username'))
      this.getData(localStorage.getItem('username'))
  },
  methods: {
    getData(username)
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 28,
        _exp: `username = '${username}'`
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length === 1)
        {
          this.form.id = ret[0].id
          this.form.groupid = ret[0].groupid
          this.form.username = ret[0].username
          this.form.passport = ret[0].passport
          this.form.mobile = ret[0].username
          this.form.truename = ret[0].truename
          this.form.gender = ret[0].gender
          this.form.areaid = ret[0].areaid
          this.form.resume = ret[0].resume
          this.form.email = ret[0].email
        }
      })
    },
    //确定修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 28,
        retAtt: 1,
        id: this.form.id,
        username: this.form.username,
        passport: this.form.passport,
        mobile: this.form.mobile,
        truename: this.form.truename,
        gender: this.form.gender,
        areaid: this.form.areaid,
        resume: this.form.resume,
        department: this.form.department,
        career: this.form.career,
        company: this.form.company,
        email: this.form.email,
        edittime: Date.parse(new Date()) / 1000
      }
      if (this.form.passport && this.form.truename && this.form.gender && this.form.areaid)
      {
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.reload()
          }
        })
      }
      else
        this.$message({message: '请将带*号的内容全部填写', type: 'error', customClass: 'mzindex'})
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/hyxx/Information.vue